import { filter } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AuthService } from '@nrwl/rx-service-auth';
import { RouterService } from '@nrwl/rx-service-router';
import { environment } from '@nrwl/environment';
import { CommonModule } from '@angular/common';
import { AdsBannerComponent } from '../../ads-banner/ads-banner.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

// import { Constants } from 'src/app/core/constants';
// import { utils } from 'src/app/core/helpers/utils';

@Component({
  selector: 'nrwl-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    CommonModule,
    AdsBannerComponent,
    RxIconModule,
    MatTooltipModule,
    RouterModule,
    MatCardModule,
    MatButtonModule,
  ],
})
export class LoginComponent implements OnInit {
  public signInForm: FormGroup;
  public rememberMe: boolean;
  public loginError: string;
  public progressVisibility = false;
  public hidePass: boolean;
  public expandEMR: boolean;
  public paddingTop = '128px';
  public paddingClasses = { small: false, middle: false, big: false };
  public isSSOPage = false;

  public authList: any[];

  public get currentYear() {
    return new Date().getUTCFullYear();
  }

  // TODO: Move login fields to auth-routing.module.ts

  constructor(
    private router: Router,
    private authService: AuthService,
    private routerService: RouterService,
    private activatedRoute: ActivatedRoute,
  ) {}

  get title() {
    return this.routerService.data.title;
  }

  ngOnInit() {
    this.hidePass = true;
    this.loginError = '';
    const urlParams = new URLSearchParams(window.location.search);

    this.isSSOPage = this.router.url === '/login/sso' || this.router.url.includes('error');
    //this.isSSOPage = this.router.url === '/v19/login/sso' || this.router.url.includes('error');

    this.authList = <any>(
      this.routerService?.route?.parent?.routeConfig?.children?.filter(
        (value) => value.path !== 'sso',
      )
    );
    this.router.events
      .pipe(filter((value) => value instanceof NavigationEnd))
      .subscribe((value) => {
        this.isSSOPage = value['url'] === '/login/sso' || value['url'].includes('error');
        //this.isSSOPage = value['url'] === '/v19/login/sso' || value['url'].includes('error');
      });

    if (this.router.url.includes('error')) {
      this.router.navigate(['login/sso'], {
        relativeTo: this.activatedRoute,
      });
      this.setPaddingTop();
      return;
    }

    // check number of form fields
    this.setPaddingTop();

    if (urlParams.toString() !== '') {
      if (this.authService.hasCanvaOAuthData(urlParams)) {
        return;
      }

      // Canva integration
      if (urlParams.has('user') && urlParams.has('state')) {
        return;
      }

      // Switch to EMR list to login
      this.expandEMR = true;
    }
  }

  public toggleEMR(returnToLogin?: boolean): void {
    this.expandEMR = !this.expandEMR;
    if (returnToLogin) {
      this.expandEMR = false;
      this.router
        .navigate(['.'], { relativeTo: this.activatedRoute })
        .then(() => this.setPaddingTop());
    }
  }

  public selectEMR(emr): void {
    this.router
      .navigate([emr.path], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'preserve',
      })
      .then(() => this.setPaddingTop());
    if (emr.path !== 'drchrono') {
      this.expandEMR = false;
    }
  }

  public forgotPasswordClicked(): void {
    this.router.navigate(['forgot-password']);
  }

  public navigateToKnowledgebase() {
    window.open('https://kb.rxphoto.com/portal/en/kb', '_blank');
  }

  private setPaddingTop(): void {
    this.setDefaultClasses();
    this.routerService.data.formFields.length === 4
      ? (this.paddingClasses.small = true)
      : this.checkIfPageIsDefault()
        ? (this.paddingClasses.big = true)
        : (this.paddingClasses.middle = true);
  }

  private setDefaultClasses(): void {
    this.paddingClasses = { small: false, middle: false, big: false };
  }

  private checkIfPageIsDefault(): boolean {
    return this.router.url === '/login';
    //return this.router.url === '/v19/login';
  }
}
